export const defaultState = { // 初始化state
  value: [],
  currentDom: null
};

export function reducer(state, action) { //选座的reducer
  // console.log('reducer', state, action);
  switch(action.type) {
  case 'CHANG_SIT':   // CHANG_SIT 座位变化事件
    return { ...state, value:action };
    break;
  case 'DEL_SIT':   // CHANG_SIT 座位变化事件
    let seats = [... state.value];
    seats.splice(action, 1);
    return { ...state, value:seats };
    break;
  default:
    throw new Error();
  }
}
